{
  "title": "Transfer settings",
  "saved": "Settings saved successfully",
  "meta": "Last updated: {{updatedAt}} by {{updatedBy}}",
  "fields": {
    "organisationNameAr": "Organisation name for the receipt (Arabic)",
    "organisationNameEn": "Organisation name for the receipt (English)",
    "declarationTextAr": "Declaration text (Arabic)",
    "declarationTextEn": "Declaration text (English)",
    "receiptFooterAr": "Receipt footer (Arabic)",
    "receiptFooterEn": "Receipt footer (English)",
    "sendSenderCopy": "Send a copy to the sender",
    "phoneVerification": "Verify the phone number with a WhatsApp code",
    "phoneVerificationHelp": "A code is sent by WhatsApp when a customer is added or a phone is changed. The record is saved only after the code is entered."
  }
}
